import { useMemo } from "react";

export enum RecommendationWidgetNameEnum {
	RecentlyViewed = "Recently Viewed",
	BestSellers = "Best Sellers",
	Complementary = "You May Also Need",
	Category = "Category Product Listing",
}

export enum ProductListingNameEnum {
	BestSellers = "Best Sellers Product Listing",
	RecentlyViewed = "Recently Viewed Product Listing",
	Category = "Category Product Listing",
	Complementary = "You May Also Need",
}

export type ProductListingNameProps = {
	widgetName?: string;
	label?: string
};

export const useGetProductListingName = ({
	widgetName,
	label
}: ProductListingNameProps) =>
	useMemo(() => {
		let name;
		if (widgetName === RecommendationWidgetNameEnum.RecentlyViewed) {
			name = ProductListingNameEnum.RecentlyViewed;
		} else if (widgetName === RecommendationWidgetNameEnum.BestSellers) {
			name = ProductListingNameEnum.BestSellers;
		} else if (widgetName === RecommendationWidgetNameEnum.Complementary) {
			name = ProductListingNameEnum.Complementary;
		} else if (widgetName === RecommendationWidgetNameEnum.Category) {
			name = ProductListingNameEnum.Category;
		} else {
			name = label || ProductListingNameEnum.Category;
		}
		return name;
	}, [widgetName, label]);

export default useGetProductListingName;
